<template>
  <div
    class="image-asset-list"
    :class="[
      align ? `image-asset-list__list--align_${align}` : ''
    ]"
  >
    <div
      v-for="(image, index) in assetList"
      :key="index"
      class="image-asset-list__image-wrapper"
      :class="[
        type ? `image-asset-list__image-wrapper--type_${type}` : ''
      ]"
    >
      <img
        class="image-asset-list__image"
        :src="`${globalImagePath}/staticImages/${image.name}`"
        :alt="image.alt"
        :title="image.name"
      >
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      align: Boolean,
      type: String,
      assetList: Array,
      globalImagePath: String,
    }
  }
</script>
